import { trackAutoEvent, track } from '../../vendor/splitmetrics-track';



export const EVENT_NAME = 'page_scroll';


export default (scrollParams, autoEvent = false) => {
  if (autoEvent) {
    trackAutoEvent(EVENT_NAME, scrollParams, {});
  } else {
    track(EVENT_NAME, scrollParams, {});
  }
};



// WEBPACK FOOTER //
// ./src/lib/track-event/page-scrolling.js